import RiskScore from './RiskScore'

export { RiskScore }
export default RiskScore
